import React, { useContext, useState, useEffect } from "react";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import RTDocuments from "components/RTDocuments/RTDocuments";
import LoadingApp from "../../components/Modal/LoadingApp";
import { makeStyles } from "@mui/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/chartsStyle.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import ErrorFallbackDialog from "components/ErrorFallback/ErrorFallbackDialog";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate } from 'react-router-dom';
import postPageVisit from "services/LogService";

const useStyles = makeStyles(styles);

export default function Documents() {
  const [redirState, setRedirState] = useState(false);
  const classes = useStyles();
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, setPage } = appContext;

  useEffect(() => {
    setPage('documents');
    postPageVisit('documents');
  }, []);

  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/documents",
      }}
    />
  );
  return (
    <ErrorBoundary
      onReset={() => setRedirState(true)}
      FallbackComponent={ErrorFallbackDialog}
      page={"documents"}
    >
      <div className={classes.container}>
        {chartIdGroup[0] !== "0" ? (
          <GridContainer>
            <GridItem xs={12}>
              <Card>
                <CardBody>
                  <RTDocuments />
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        ) : <LoadingApp open={chartIdGroup[0] === "0" ? true : false} />
        }
      </div>
      {redirecting}
    </ErrorBoundary>
  );
}
